<template>
  <div class="container py-5 terms-conditions">
    <h1 class="mb-3 display-5 fw-bold text-primary animate__animated animate__fadeInDown">
      <i class="fas fa-gavel me-2"></i> Termeni și Condiții
    </h1>
    <p class="text-muted animate__animated animate__fadeIn animate__delay-1s">
      Ultima actualizare: Mai 2025
    </p>

    <div class="mt-5">
      <div class="terms-item mb-5 animate__animated animate__fadeInUp">
        <h4><i class="fas fa-check-circle me-2 text-primary"></i> 1. Acceptarea termenilor</h4>
        <p>
          Prin accesarea și utilizarea acestui site, sunteți de acord cu acești Termeni și Condiții. Dacă nu sunteți de acord, vă rugăm să nu folosiți site-ul.
        </p>
      </div>

      <div class="terms-item mb-5 animate__animated animate__fadeInUp animate__delay-1s">
        <h4><i class="fas fa-concierge-bell me-2 text-primary"></i> 2. Servicii oferite</h4>
        <p>
          Site-ul oferă informații și servicii de consultanță în achiziții publice. Ne rezervăm dreptul de a modifica sau întrerupe parțial sau total serviciile fără notificare prealabilă.
        </p>
      </div>

      <div class="terms-item mb-5 animate__animated animate__fadeInUp animate__delay-2s">
        <h4><i class="fas fa-user-lock me-2 text-primary"></i> 3. Crearea contului</h4>
        <p>
          Pentru a interacționa cu un consultant, utilizatorii pot crea un cont folosind un nume, email și o parolă. Sunteți responsabil pentru securitatea contului dvs.
        </p>
      </div>

      <div class="terms-item mb-5 animate__animated animate__fadeInUp animate__delay-3s">
        <h4><i class="fas fa-exclamation-circle me-2 text-primary"></i> 4. Răspundere</h4>
        <p>
          Nu ne asumăm răspunderea pentru deciziile luate de utilizatori pe baza informațiilor de pe site. Recomandăm consultarea personalizată.
        </p>
      </div>

      <div class="terms-item animate__animated animate__fadeInUp animate__delay-4s">
        <h4><i class="fas fa-edit me-2 text-primary"></i> 5. Modificări</h4>
        <p>
          Putem modifica acești termeni oricând. Vă recomandăm să verificați periodic această pagină.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.terms-conditions {
  line-height: 1.8;
  color: #333;
}
.terms-item h4 {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.terms-item p {
  margin-left: 2.2rem;
  color: #555;
}
</style>
